"use strict";

const wishlist_items = JSON.parse(
  localStorage.getItem("milano__wishlist-items")
);
const wishlistDiv = document.querySelector(".wishlist-page-main");

var WishlistPageShopify = (function () {
  return {
    initWishlistItems: function () {
      if (window.location.search.indexOf("page=") == -1) {
        this.init();
      }
    },

    init: function () {
      const _this = this;
      if (wishlistDiv) {
        const div_no_product = wishlistDiv.querySelector(".wishlist-no-product-js");

        if (wishlist_items === null || wishlist_items.length === 0) {
          _this.skeletonFunction(0);
          div_no_product.classList.remove("hidden");
        } else {
          var query = "";
          wishlist_items.forEach((e, key, wishlist_items) => {
            if (!Object.is(wishlist_items.length - 1, key)) {
              query += e + "%20OR%20id:";
            } else {
              query += e;
            }
          });

          const section_id = document.querySelector(".wishlist-page-section").dataset.sectionId;
          var productAjaxURL =
            "?section_id=" + section_id +
            "&type=product&options[unavailable_products]=last&q=id:" + query;

          fetch(`${window.routes.search_url}${productAjaxURL}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = parser.parseFromString(responseText, "text/html");
              const exist_row = wishlistDiv.querySelector(".wishlist-list-items");
              if (exist_row) exist_row.remove();

              const er = html.querySelector(".wishlist-page-main .wishlist-list-items");
              if (wishlist_items.length !== 0 && er) {
                wishlistDiv.innerHTML = html.querySelector(".wishlist-page-main").innerHTML;
                _this.skeletonFunction(700);
                setTimeout(() => {
                  _this.initRemoveButtons();
                }, 800);
              } else {
                _this.skeletonFunction(0);
                div_no_product.classList.remove("hidden");
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              initLazyloadItem();
            });
        }
      }
    },

    initRemoveButtons: function () {
      const _this = this;
      if (!wishlistDiv) return;

      // Purana listener remove karo (duplicate avoid)
      const oldDiv = wishlistDiv.cloneNode(true);
      wishlistDiv.parentNode.replaceChild(oldDiv, wishlistDiv);

      // Naye wishlistDiv reference lo
      const newWishlistDiv = document.querySelector(".wishlist-page-main");

      newWishlistDiv.addEventListener("click", function (e) {
        const removeBtn = e.target.closest("button-wishlist[data-action='go_to_page']");
        if (!removeBtn) return;

        e.preventDefault();
        e.stopPropagation();

        const productId = removeBtn.dataset.productId;
        const productCard = removeBtn.closest(".wishlist-list");

        // localStorage update karo
        let stored = JSON.parse(localStorage.getItem("milano__wishlist-items") || "[]");
        stored = stored.filter((id) => id !== productId);
        localStorage.setItem("milano__wishlist-items", JSON.stringify(stored));

        // DOM se hatao
        if (productCard) {
          productCard.style.transition = "opacity 0.3s ease";
          productCard.style.opacity = "0";
          setTimeout(() => productCard.remove(), 300);
        }

        // Agar wishlist empty ho gayi
        if (stored.length === 0) {
          setTimeout(() => {
            const div_no_product = document.querySelector(".wishlist-page-main .wishlist-no-product-js");
            if (div_no_product) div_no_product.classList.remove("hidden");
          }, 350);
        }
      });
    },

    skeletonFunction: function (timer) {
      window.setTimeout(function () {
        if (this.document.querySelector("skeleton-page")) {
          this.document.querySelector("skeleton-page").remove();
        }
        if (this.document.querySelector(".wishlist-page-section-inner")) {
          this.document.querySelector(".wishlist-page-section-inner").classList.remove("hidden");
        }
      }, timer);
    },
  };
})();

WishlistPageShopify.initWishlistItems();